import { SUBSCRIPTION_PLAN } from '@gymaholic/packages'

export function isCoachingSubscriptionUserUtil (subscriptionPlan) {
  return [
    SUBSCRIPTION_PLAN.COACHING,
    SUBSCRIPTION_PLAN.EARLY_BIRD_COACHING
  ].includes(subscriptionPlan)
}
